<template>
  <div class="">
    <v-card class="no-shadow">
      <v-card-title class="ctn_search">
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="getHeader"
        :items="this.list"
        :sort-by="['createDate']"
        :sort-desc="[true]"
        loading-text="Cargando información …."
        :search="search"
      >
        <template v-slot:[`header.name`]="{ header }">
          {{ header.text.toUpperCase() }}
        </template>
        <template v-slot:[`item.device.state`]="{ item }">
          <div v-if="item.device.state == true">
            <v-icon class="i-con on">mdi-checkbox-blank-circle</v-icon>
          </div>
          <div v-else>
            <v-icon class="i-con off">mdi-checkbox-blank-circle</v-icon>
          </div>
        </template>
        <template v-slot:[`item.device.activate`]="{ item }">
          <div class="lb lb_activo" v-if="item.device.activate == 1">
            Activo
          </div>
          <div class="lb lb_inactivo" v-else>
            <span class="span_inactive">Inactivo</span>
          </div>
        </template>
        <template v-slot:[`item.device.switch`]="{ item }">
          <div class="lb" v-if="item.device.switch === true">
            <span class="lbs sw_active">Encendido</span>
          </div>
          <div class="lb" v-else>
            <span class="lbs sw_inactive">Apagado</span>
          </div>
        </template>
        <template v-slot:[`item.device.CounterToday`]="{ item }">
          <span>{{ item.device.CounterToday | twoDigit }}</span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="table_menu"
                color="primary"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item class="list_action">
                <v-btn plain @click="deleteItem(item)">
                  <span>Quitar</span>
                </v-btn>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
    <Delete
      :data="itemObjct"
      :IdIntegrator="this.IdIntegrator"
      :visible="DeleteFlag"
      @close="DeleteFlag = false"
    ></Delete>
  </div>
</template>
<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import Delete from "@/components/network/DeleteDevice.vue";
export default {
  name: "NetworkTableDevicesComp",
  props: {
    IdIntegrator: {
      type: String
    },
    list: {
      type: Array
    }
  },
  components: {
    Delete
  },
  data() {
    return {
      search: "",
      DeleteFlag: false,
      itemObjct: {},
      headerMaster: [
        { text: "-", value: "device.state" },
        { text: "Estado", value: "device.activate" },
        { text: "IDX", value: "device.idx" },
        { text: "Switch", value: "device.switch" },
        { text: "Empresa", value: "device.company.name" },
        { text: "NUI", value: "device.nui", align: "start" },
        { text: "Tipo", value: "device.subTypeService" },
        { text: "Perfil", value: "device.profile" },
        { text: "Consumo", value: "device.CounterToday" },
        { text: "Acciones", value: "actions", sortable: false }
      ],
      headersClient: [
        { text: "-", value: "device.state" },
        { text: "Estado", value: "device.activate" },
        { text: "IDX", value: "device.idx" },
        { text: "Switch", value: "device.switch" },
        { text: "Empresa", value: "device.company.name" },
        { text: "NUI", value: "device.nui", align: "start" },
        { text: "Serial", value: "device.serial", align: "start" },
        { text: "Cod. Interno", value: "device.alternateCode", align: "start" },
        { text: "Tipo", value: "device.subTypeService" },
        { text: "Perfil", value: "device.profile" },
        { text: "Consumo", value: "device.CounterToday" },
        { text: "Acciones", value: "actions", sortable: false }
      ]
    };
  },
  async mounted() {
    await this.getLoadTable;
    // evento despues de nueva estacion
    this.$root.$on("reload", async () => {
      await this.getLoadTable;
    });
  },
  methods: {
    ...mapActions(["listDevice"]),
    deleteItem(param) {
      this.itemObjct = Object.assign({}, param);
      this.DeleteFlag = true;
    }
  },
  computed: {
    ...mapGetters(["", "isMaster"]),
    getLoadTable() {
      if (this.list.length > 0) {
        return false;
      }
      return true;
    },
    getHeader() {
      if (this.isMaster == 1) {
        return this.headerMaster;
      }
      return this.headersClient;
    }
  },
  filters: {
    twoDigit(val) {
      let units = val.slice(-3);
      return `${parseFloat(val).toFixed(2)} ${units}`;
    },
    porcent(val) {
      return parseFloat(val).toFixed(0);
    },
    formatDateFrom: (value) => {
      if (value) {
        return moment(value).locale("es").fromNow();
      }
      return "-";
    },
    formatDateShort: (value) => {
      if (value) {
        return moment(value).locale("es").format("LL");
      }
      return "-";
    },
    formatDate: (value) => {
      if (value) {
        return moment(value).locale("es").format("LLL");
      }
      return "-";
    }
  }
};
</script>
<style lang="scss">
@import "../../assets/scss/base.scss";
.ctn_lasdata {
  p {
    margin: 0;
    &.ctn_lasdata_date {
      font-weight: 600;
      font-size: 0.8rem;
      margin-bottom: 0;
    }
    &.ctn_lasdata_item {
      span {
        border-radius: 4px;
        padding: 1px 5px;
        background-color: $dark-jungle-green;
        color: $light-cyan;
        &.none {
          color: $color-text-grey;
          background-color: transparent;
        }
      }
    }
  }
}
.table_menu {
  background-color: hsl(120deg 100% 25% / 4%);
}
.span_inactive {
  color: $alert;
}
.list_action {
  padding: 0 2px;
  &:last-child {
    button:hover,
    a:hover {
      background-color: $alert;
    }
  }
  a,
  button {
    color: $color-text;
    text-decoration: none;
    display: block;
    font-size: 0.9rem;
    padding: 6px 16px;
    border-radius: 2px;
    &.cent {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    width: 100%;
    &:hover {
      color: #fff;
      background-color: $color-link;
    }
  }
  span {
    font-size: 0.9rem;
  }
}
span.lbs {
  border-radius: 4px;
  font-size: 0.75rem;
  margin: 2px;
  &.sw_active {
    color: #fff;
    padding: 5px 10px;
    background-color: $bag-green;
  }
  &.sw_inactive {
    padding: 5px 10px;
    background-color: $alert;
    color: #fff;
  }
}
i.i-con {
  font-size: 0.8rem !important;
  &.off {
    color: $alert;
  }
  &.on {
    color: $green-btn;
  }
}
</style>
